import React from 'react';
import { Input, Row, Col } from 'antd';
import dayjs from 'dayjs';

const TasksSearch = ({ tasksData, searchText, setSearchText, setFilteredData }) => {
  const handleSearch = (value) => {
    const search = value.toLowerCase();
    setSearchText(value);

    const filtered = tasksData.filter(record => {
      return (
        record.name?.toLowerCase().includes(search) ||
        record.status?.name?.toLowerCase().includes(search) ||
        record.responsible_area?.name?.toLowerCase().includes(search) ||
        record.condition?.toLowerCase().includes(search) ||
        (record.date_committed ? dayjs(record.date_committed).format('DD/MM/YYYY').toLowerCase().includes(search) : false) ||
        record.gap?.dependency_control?.dependency?.asset?.name?.toLowerCase().includes(search) ||
        record.gap?.dependency_control?.dependency?.name?.toLowerCase().includes(search) ||
        record.gap?.dependency_control?.control?.title?.toLowerCase().includes(search) ||
        record.gap?.type?.toLowerCase().includes(search) ||
        record.gap?.area?.name?.toLowerCase().includes(search) ||
        record.issue?.type?.toLowerCase().includes(search)
      );
    });

    setFilteredData(filtered);
  };


  const handleReset = () => {
    setSearchText(''); 
    setFilteredData(tasksData);
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Tareas"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default TasksSearch;